import { Profile, School } from '.';

export type Admin = {
  id: string;
  email: string;
  emailActivated: boolean;
  phoneActivated: boolean;
  createdAt: string;
  profile: Profile;
  role: EAdminRoles;
  school: School | string;
  schoolName: string;
  timezone: number;
  firstName?: string;
  lastName?: string;
  userType?: string;
  dataSource?: string | null;
  studentCount?: number;
};

export type CreatedAdmin = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  school: School;
  role: EAdminRoles;
};

export type UpdatedAdmin = {
  email: string;
  firstName: string;
  lastName: string;
  school: School;
};

export type TableAdmin = {
  key: string;
  id: string;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  school: School;
  schoolName: string;
  role: EAdminRoles;
  dataSource: string;
  studentCount: number;
};

export enum EAdminRoles {
  SCHOOL_ADMIN = 'teacher-admin',
  SUPER_ADMIN = 'super-admin'
}
